// removed by extract-text-webpack-plugin
module.exports = {"sm":"only screen and (min-width: 48em)","xsmall":"only screen and (min-width: 375px)","small":"only screen and (min-width: 481px)","medium":"only screen and (min-width: 768px)","large":"only screen and (min-width: 993px)","xlarge":"only screen and (min-width: 1201px)","midyear":"midyear-3eRRu","topoWrapper":"topoWrapper-3pNwa","placeholder":"placeholder-3wsxo"};


//////////////////
// WEBPACK FOOTER
// ./src/components/yearInReview/2018/midyear/_mid2018.css
// module id = 1298
// module chunks = 1